require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DataTableRow = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var React = _interopRequireWildcard(require("react"));

var _color = _interopRequireDefault(require("color"));

var _reactNative = require("react-native-web/dist/index");

var _TouchableRipple = _interopRequireDefault(require("../TouchableRipple"));

var _colors = require("../../styles/colors");

var _theming = require("../../core/theming");

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/DataTable/DataTableRow.tsx";

var DataTableRow = function (_React$Component) {
  (0, _inherits2["default"])(DataTableRow, _React$Component);

  function DataTableRow() {
    (0, _classCallCheck2["default"])(this, DataTableRow);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(DataTableRow).apply(this, arguments));
  }

  (0, _createClass2["default"])(DataTableRow, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onPress = _this$props.onPress,
          style = _this$props.style,
          theme = _this$props.theme,
          rest = (0, _objectWithoutProperties2["default"])(_this$props, ["onPress", "style", "theme"]);
      var borderBottomColor = (0, _color["default"])(theme.dark ? _colors.white : _colors.black).alpha(0.12).rgb().string();
      return React.createElement(_TouchableRipple["default"], (0, _extends2["default"])({}, rest, {
        onPress: onPress,
        style: [styles.container, {
          borderBottomColor: borderBottomColor
        }, style],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 36
        }
      }), React.createElement(_reactNative.View, {
        style: styles.content,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 41
        }
      }, this.props.children));
    }
  }]);
  return DataTableRow;
}(React.Component);

exports.DataTableRow = DataTableRow;
(0, _defineProperty2["default"])(DataTableRow, "displayName", 'DataTable.Row');

var styles = _reactNative.StyleSheet.create({
  container: {
    borderStyle: 'solid',
    borderBottomWidth: _reactNative.StyleSheet.hairlineWidth,
    minHeight: 48,
    paddingHorizontal: 16
  },
  content: {
    flex: 1,
    flexDirection: 'row'
  }
});

var _default = (0, _theming.withTheme)(DataTableRow);

exports["default"] = _default;